import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import bannerBg from "images/section-bg-search-slide1.jpg";
import bannerBg1 from "images/section-bg-search-slide2.jpg";
import bannerBg2 from "images/section-bg-search-slide3.jpg";
import theWire from "images/thewire-logo.png";
import SearchInputHomePage from "components/shared/SearchInput/SearchInput";
import { HeroContainer, HeroBackground } from "./styles/Hero.style";
import { Chip } from "@material-ui/core";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";
import Pilar from "./Pilar";
import pilar1 from "images/pilar1.jpg";
import pilar2 from "images/pilar2.jpg";
import pilar3 from "images/pilar3.jpg";
import pilar4 from "images/pilar4.jpg";

export function Hero(props) {
  const { heroTitle, showEasyCheckout } = props;

  const [state, setState] = useState({
    backgroundImage: bannerBg,
    searchInputValue: "",
    formError: false
  });

  React.useEffect(() => {
    const images = [bannerBg, bannerBg1, bannerBg2];
    setState((prev) => ({
      ...prev,
      backgroundImage: images[Math.floor(Math.random() * images.length)]
    }));
  }, []);

  const dispatch = useDispatch();

  const onClickCategory = (category) =>
    dispatch(push(`/licensing/search?q=&page=1&category=${category}`));

  return (
    <div style={{ background: "black" }}>
      <HeroBackground>
        <HeroContainer backgroundImage={state.backgroundImage}>
          <div className="layer" />
          <div className="callout">
            {props.wire ? (
              <img className="wireLogo" src={theWire} alt="THE WIRE" />
            ) : (
              <>
                <h1 className="hero-title-desktop">
                  Authentic <span className="title-highlight">Videos,</span> Extraordinary{" "}
                  <span className="title-highlight">Performance</span>
                </h1>
                <div className="hero-title-mobile-container">
                  <h1 className="hero-title-mobile">
                    Authentic <span className="title-highlight">Videos,</span>
                  </h1>
                  <h1 className="hero-title-mobile">Extraordinary</h1>
                  <h1 className="hero-title-mobile">
                    <span className="title-highlight">Performance</span>
                  </h1>
                </div>
              </>
            )}
            <SearchInputHomePage homepage />
            <div className="popular-categories">
              <h5>Popular Categories</h5>
              <div className="popular-categories-container">
                <Chip label={"Fails"} key={"Fails"} onClick={() => onClickCategory("Fails")} />
                <Chip label={"Humor"} key={"Humor"} onClick={() => onClickCategory("Humor")} />
                <Chip label={"Pets"} key={"Pets"} onClick={() => onClickCategory("Pets")} />
                <Chip
                  label={"Uplifting"}
                  key={"Uplifting"}
                  onClick={() => onClickCategory("Uplifting")}
                />
                <Chip label={"Family"} key={"Family"} onClick={() => onClickCategory("Family")} />
              </div>
            </div>
          </div>

          {!showEasyCheckout && props.children && <>{props.children}</>}
        </HeroContainer>

        <div className="pilar-container">
          <div className="pilar-row">
            <Pilar
              image={pilar1}
              title="Entertainment Licensing"
              description="From Clip Shows to Documentaries to Movies and everything in between, Jukin’s library can fulfill all your production needs."
              link="https://campaign.jukinmedia.com/jmlicensing/#entertainment"
            />
            <Pilar
              image={pilar2}
              title="Brand & Agency Licensing"
              description="Connecting global brands, advertising, and creative agencies with their consumers by delivering real moments told through UGC and authentic stories."
              link="https://campaign.jukinmedia.com/jmlicensing/#brandagency"
            />

            <Pilar
              image={pilar3}
              title="Custom Research & Clearance Licensing"
              description="We are not confined to the videos in our Library. Activate our expert curation team to source and acquire exactly what you are looking for."
              link="https://campaign.jukinmedia.com/jmlicensing/#clearance"
            />

            <Pilar
              image={pilar4}
              title="Self Service Editorial Licensing"
              description="Designed for digital publishers to engage and interact with their fans and followers with just a few clicks."
              reference="/licensing/pricing"
            />
          </div>
        </div>

        <div className="pilar-container-tablet">
          <div className="pilar-row pilar-row-tablet">
            <div className="pilar-wrapper-tablet">
              <Pilar
                image={pilar1}
                title="Entertainment Licensing"
                description="From Clip Shows to Documentaries to Movies and everything in between, Jukin’s library can fulfill all your production needs."
                link="https://campaign.jukinmedia.com/jmlicensing"
              />
              <Pilar
                image={pilar2}
                title="Brand & Agency Licensing"
                description="Connecting global brands, advertising, and creative agencies with their consumers by delivering real moments told through UGC and authentic stories."
                link="https://campaign.jukinmedia.com/jmlicensing"
              />
            </div>

            <div>
              <Pilar
                image={pilar3}
                title="Custom Research & Clearance Licensing"
                description="We are not confined to the videos in our Library. Activate our expert curation team to source and acquire exactly what you are looking for."
                link="https://campaign.jukinmedia.com/jmlicensing"
              />

              <Pilar
                image={pilar4}
                title="Self Service Editorial Licensing"
                description="Designed for digital publishers to engage and interact with their fans and followers with just a few clicks."
                reference="/licensing/pricing"
              />
            </div>
          </div>
        </div>
      </HeroBackground>
    </div>
  );
}

Hero.propTypes = {
  clearAllSearch: PropTypes.func.isRequired,
  history: PropTypes.shape().isRequired,
  showEasyCheckout: PropTypes.bool
};

Hero.defaultProps = {
  showEasyCheckout: true
};

export default withRouter(Hero);
